<div class="feedback-details-audit-trail">
	<div class="feedback-details-header">
		<span class="feedback-details-title">Feedback details</span>
	</div>
	<div class="loading-state" *ngIf="isLoading">Loading feedback details...</div>
	<div class="error-state" *ngIf="errorMessage">{{ errorMessage }}</div>
	<owc-table class="feedback-details-table" *ngIf="!isLoading && !errorMessage && dataSource.length; else noFeedbackDetails">
		<owc-table-header sticky>
			<owc-table-header-cell>Account ID</owc-table-header-cell>
			<owc-table-header-cell>Account Name</owc-table-header-cell>
			<owc-table-header-cell>Status</owc-table-header-cell>
			<owc-table-header-cell>LSO Acknowledgement</owc-table-header-cell>
			<owc-table-header-cell>Comments</owc-table-header-cell>
			<owc-table-header-cell>Submitter</owc-table-header-cell>
			<owc-table-header-cell>Questions and Answers</owc-table-header-cell>
		</owc-table-header>

		<owc-table-body>
			<ng-container *ngFor="let row of pagedData">
			<owc-table-row>
				<owc-table-simple-cell class="cell-value">{{ row.AccountId }}</owc-table-simple-cell>
				<owc-table-simple-cell class="cell-value">{{ row.AccountName }}</owc-table-simple-cell>
				<owc-table-simple-cell class="cell-value">{{ row.Status }}</owc-table-simple-cell>
				<owc-table-simple-cell class="cell-value">{{ row.IsLsoAcknowledged }}</owc-table-simple-cell>
				<owc-table-simple-cell class="long-value">{{ row.CustomerAttachment }}</owc-table-simple-cell>
				<owc-table-simple-cell class="long-value">{{ row.Submitter }}</owc-table-simple-cell>
				<owc-table-simple-cell class="cell-value">
					<button
						type="button"
						class="expand-toggle"
						[disabled]="!hasFeedbackDetails(row)"
						[attr.aria-expanded]="expandedElement === row"
						(click)="expandToggle(row)">
						<span>{{ hasFeedbackDetails(row) ? 'View feedback' : '-' }}</span>
						<owc-icon *ngIf="hasFeedbackDetails(row)" [name]="expandedElement === row ? 'chevron_up' : 'chevron_down'" family="outlined"></owc-icon>
					</button>
				</owc-table-simple-cell>
			</owc-table-row>
			<owc-table-row *ngIf="expandedElement === row" class="feedback-detail-row">
				<owc-table-simple-cell class="feedback-detail-cell" [attr.colspan]="7">
					<div class="feedback-detail-list">
						<div class="feedback-detail-content" *ngFor="let question of row.QuestionsAndAnswers; let questionIndex = index">
							<div class="feedback-detail-title">Feedback {{ questionIndex + 1 }}</div>
							<div class="feedback-detail-field">
								<span class="feedback-detail-label">Question</span>
								<span class="feedback-detail-value">{{ question.FeedbackQuestion || '-' }}</span>
							</div>
							<div class="feedback-detail-field">
								<span class="feedback-detail-label">Answer</span>
								<span class="feedback-detail-value">{{ question.FeedbackAnswer || '-' }}</span>
							</div>
						</div>
					</div>
				</owc-table-simple-cell>
			</owc-table-row>
			</ng-container>
		</owc-table-body>
	</owc-table>

	<ng-template #noFeedbackDetails>
		<p class="empty-state" *ngIf="!isLoading && !errorMessage">No feedback details available.</p>
	</ng-template>
	<div class="simple-pagination" *ngIf="totalCount > 0">
      <div class="pagination-left">
        <span class="items-per-page-label">Items per page:</span>
				<div class="page-size-control">
					<button
						type="button"
						class="page-size-dropdown"
						aria-haspopup="listbox"
						aria-controls="page-size-options"
						[attr.aria-expanded]="isPageSizeMenuOpen"
						(click)="togglePageSizeMenu()">
						<span>{{ pageSize }}</span>
						<owc-icon name="chevron_down" family="outlined"></owc-icon>
					</button>
					<div
						*ngIf="isPageSizeMenuOpen"
						id="page-size-options"
						class="page-size-options"
						role="listbox"
						aria-label="Items per page"
						(keydown.escape)="isPageSizeMenuOpen = false">
						<button
							*ngFor="let size of pageSizeOptions"
							type="button"
							class="page-size-option"
							role="option"
							[class.selected]="size === pageSize"
							[attr.aria-selected]="size === pageSize"
							(click)="onPageSizeChange(size)">
							{{ size }}
						</button>
					</div>
				</div>
      </div>
      
      <div class="pagination-center">
        <span class="pagination-info">{{ startIndex }} &nbsp; - &nbsp; {{ endIndex }} &nbsp; of &nbsp; {{ totalCount }}</span>
      </div>
      
      <div class="pagination-right">
        <button 
          class="nav-button" 
          [disabled]="currentPage === 0"
          (click)="goToFirstPage()"
          title="First page">
          &#8810;
        </button>
        <button 
          class="nav-button" 
          [disabled]="currentPage === 0"
          (click)="goToPreviousPage()"
          title="Previous page">
          &#8249;
        </button>
        <button 
          class="nav-button" 
          [disabled]="currentPage >= totalPages - 1"
          (click)="goToNextPage()"
          title="Next page">
          &#8250;
        </button>
        <button 
          class="nav-button" 
          [disabled]="currentPage >= totalPages - 1"
          (click)="goToLastPage()"
          title="Last page">
          &#8811;
        </button>
				<owc-button (click)="close()">Close</owc-button>
      </div>
    </div>

	<div *ngIf="totalCount === 0" class="no-data-pagination">
		<div class="pagination-right">
			<owc-button (click)="close()">Close</owc-button>
		</div>
	</div>
</div>
